import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import headerLogo from '../assets/Images/headerlogo.png';

const navItems = [
  { name: "HOME", path: "/" },
  { name: "ABOUT US", path: "/about" },
  { name: "OUTDOOR", path: "/outdoor" },
  { name: "INDOOR", path: "/indoor" },
  { name: "HOTEL & RESTAURANT", path: "/hotel-restaurant" },
  { name: "PACKAGES", path: "/packages" },
  { name: "NEWS", path: "/news" },
  { name: "EVENTS", path: "/events" },
  { name: "CONTACT", path: "/contact" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  // Track screen resize to determine when to show toggle button
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(false); // Close menu if switching to desktop
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavLinkClick = () => {
    if (isMobile) {
      setMenuOpen(false); // auto-close on link click in mobile
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-white">
      <div className="container-fluid navigation">

        {/* Logo */}
        <img src={headerLogo} alt="Company Logo" height={40} />

        {/* Custom Toggle Button */}
        {isMobile && (
          <button
            className="custom-toggle-button"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        )}

        {/* Navigation Items */}
        <div
          className={`collapse navbar-collapse py-5 py-md-0 ${menuOpen ? "show" : "hide"}`}
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 menu">
            {navItems.map((item) => (
              <li className="nav-item" key={item.name}>
                <Link className="nav-link" to={item.path} onClick={handleNavLinkClick}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          <div className="membership bg-light">
            <Link to="/membership" className="text-decoration-none" onClick={handleNavLinkClick}>
              MEMBERSHIP
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
